export default __webpack_public_path__ + "static/media/gummies@2x.878fbe57.png";